import React, { Component } from 'react'
import { withNamespaces } from "react-i18next";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { Icon } from '@iconify/react';
import DataTable from "../../components/Datatable/DataTable";

import MobileAgentComission from "./MobileAgentComission";

class AgentComission extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = {};
    }

    render() 
    {
        const { t } = this.props;
        
        const columns = 
        [
            { 
                text: t('commission-illustrate.total-win-lose'), 
                formatter: (cell, row) => 
                {
                    if(row.operation === 'any')
                    {
                        return 'Any Amount';
                    }
                    else if(row.operation === 'between')
                    {
                        return `${t('commission-illustrate.amount')}: ${t('commission-illustrate.between')} ${row.min} ${t('commission-illustrate.and')} ${row.max}`
                    }
                    else
                    {
                        return `${t('commission-illustrate.amount')}: ${t('commission-illustrate.less-than')} ${row.min} ${t('commission-illustrate.or-greater-than')} ${row.max}`
                    }
                },
            },
            { 
                text: t('commission-illustrate.min-active-req'), 
                dataField: 'min_active' 
            },
            { 
                text: t('commission-illustrate.commission-rate'), 
                formatter: (cell, row) => 
                {
                    return `${row.percentage}%`;
                },
            },
        ];
        
        return (
            <Auxiliary>
                {isDesktop ? (
                    <div className="content-wrap" >
                        <h4 className="mt-5">{t('commission-illustrate.agent-comm-notice-8')}</h4>
                        {/* <p>
                            The agent’s commission ratio is determined by the two conditions of the total wins and losses of the month and the number of active people, and the commission ratio of the corresponding level will be obtained when they are met at the same time.<br />
                            • Active number: monthly deposit = 100 or effective betting = 500;
                        </p> */}
                        <div className="card-shadow">
                            <DataTable
                                keyField="no"
                                data={this.props.data}
                                columns={columns}
                                activePage={this.props.activePage}
                                limit={this.props.limit}
                                totalItems={this.props.totalRecords}
                                paginationHandler={(val) => this.datatablesChangeHandler(val, "activePage")}
                                loading={this.props.loading}
                                hideSearchBar={true}
                                hideTotalRecords={true}
                                hidePagination={true}
                                classValue="pd-table"
                                component="delegate-deposit-history"
                            />
                        </div>
                        <br/>
                        {/* <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" />{t('commission-illustrate.agent-comm-notice-1')}</p>
                        <h4 className="mt-5">{t('commission-illustrate.agent-comm-notice-5')}</h4>
                        <ul>
                            <li>
                                <p>{t('commission-illustrate.commission')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-2')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-4')}</p>
                            </li>
                            <li>
                                <p>{t('commission-illustrate.expenses')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-3')}</p>
                            </li>
                            <li>
                                <p>Net profit or loss after reversal</p>
                                <p>Net profit or loss of the current month + balance of the previous month;</p>
                            </li>
                            <li>

                                <p>Net win or loss of the month</p>
                                <p>total win or loss of the month - bonus - rebate - venue fee + account adjustment + win or loss of make-up order - deposit and withdrawal fee;</p>
                            </li>
                            <li>
                                <p>Bonus</p>
                                <p>the sum of bonuses distributed by the platform received by the agent’s offline members in the current month; </p>
                            </li>
                            <li>
                                <p>Rebates</p>
                                <p>the sum of platform rebates received by the downline members acting as agents in the current month; </p>
                            </li>
                            <li>
                                <p>Venue fee</p>
                                <p>total wins and losses of each game venue * platform fee rate, but the platform will only charge the venue fee if it generates profits in the current month;</p>
                            </li>
                            <li>
                                <p>Account adjustment</p>
                                <p>when the membership flow is abnormal, the site administrator will adjust the account of the member; </p>
                            </li>
                            <li>
                                <p>Make-up order win or loss</p>
                                <p>net win or loss of real-time data in the previous month - net win or loss of commission issued in the previous month; </p>
                            </li>
                            <li>
                                <p>Deposit fee</p>
                                <p>deposit amount of lower-level members * deposit rate + agent line recharge amount * deposit rate</p>
                            </li>
                            <li>
                                <p>Withdrawal fee</p>
                                <p>withdrawal amount of subordinate members * withdrawal rate; </p>
                            </li>
                            <li>
                                <p>Commission supplementary adjustment</p>
                                <p>After the monthly commission is issued, the commission will be supplemented after verification based on the relevant activities the agent has participated in or other reasons.</p>
                            </li>
                        </ul>
                        <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" /> {t('commission-illustrate.agent-comm-notice-6')}</p>*/}
                    </div>
                ) : (
                    <MobileAgentComission 
                        {...this.state}
                        {...this.props}
                        columns={columns}
                    />
                )}
            </Auxiliary>
        )
    }
}

export default withNamespaces("translation")(AgentComission);